import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _empty = {};
var _publicNotifyRequest = {};
function resolveComWixpressPingHubApiPublicNotificationsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/notifications-hub-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/ping/hub',
                destPath: '',
            },
            {
                srcPath: '/_api/ping/notifications',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/ping/hub',
                destPath: '',
            },
            {
                srcPath: '/_api/ping/notifications',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/notifications/v3/notify',
                destPath: '/v3/notify',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Sends notifications to recipients. */
export function notify(payload) {
    var _a = serializer(_publicNotifyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_empty, {}).fromJSON;
    function __notify(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.notifications.v1.public_notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.hub.api.PublicNotificationsService.Notify',
            url: resolveComWixpressPingHubApiPublicNotificationsServiceUrl({
                protoPath: '/api/v1/notify',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __notify.fromReq = fromReq;
    __notify.__isAmbassador = true;
    return __notify;
}
//# sourceMappingURL=http.impl.js.map